<template>
  <div class="card">
    <div class="header">
      <div class="bg-image">
        <img :src="require(`./images/bg-${bgImage}.png`)" alt="" />
      </div>
      <div class="title">
        <span class="text">{{ title }}</span>
        <span :class="['num', { normal: parseInt(totalNum) === 0 }]">{{
          totalNum
        }}</span>
      </div>
      <div class="classify-list">
        <div>
          <img
            :src="require(`./images/${imgName}.png`)"
            alt=""
            class="title-img"
          />
        </div>
        <ul class="list">
          <li class="item" v-for="item in titleList" :key="item.text">
            <span class="triangle"></span>
            <span class="text">{{ item.text }}</span>
            <span :class="['num', { normal: item.num === 0 }]">{{
              item.num > 9999999 ? '>1000万' : item.num
            }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="body">
      <ul
        class="body-list"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="isLastPage"
      >
        <li
          :class="['body-ltem', cursor ? 'cursor' : '']"
          v-for="item in briefList"
          :key="item.id"
        >
          <div class="title">{{ item.title }}</div>
          <div
            class="brief-item"
            v-for="(briefItem, index) in item.briefItemList"
            :key="index"
          >
            {{ briefItem }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgImage: {
      type: String,
      default: 'circle'
    },
    title: {
      type: String,
      default: ''
    },
    totalNum: {
      type: String,
      default: ''
    },
    imgName: {
      type: String,
      default: 'note'
    },
    titleList: {
      type: Array,
      default() {
        return [];
      }
    },
    briefList: {
      type: Array,
      default() {
        return [];
      }
    },
    cursor: {
      type: Boolean,
      default: false
    },
    isLastPage: Boolean
  },
  methods: {
    loadMore() {
      this.$emit('loadMore');
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
.body
  overflow auto
  .body-ltem
    height auto !important
    text-align center
    .title
      font-weight bold
      margin-bottom 5px
    .brief-item
      line-height 25px
</style>
